import React from 'react'

const services = [
  [
    { name: 'Ring Setting', field: 'ringSetting' },
    { name: 'Custom Jewelry', field: 'customJewelry' }
  ],
  [
    { name: 'Jewelry Repair', field: 'jewelryRepair' },
    { name: 'Appraisals', field: 'appraisals' }
  ],
  [
    { name: 'Insurance', field: 'insurance' },
    { name: 'Consultation', field: 'consultation' }
  ],
  [
    { name: 'Brand Rings', field: 'brandRings' },
    { name: 'Purchasing', field: 'purchasing' }
  ]
]

export default ({ data, onChangeFactory, disabled }) =>
  <fieldset>
    <section>
      {services.map((row, index) =>
        <div className="row" key={index}>
          {row.map(({ name, field }) =>
            <div className="col col-4" key={field}>
              <label className="checkbox">
                <input
                  type="checkbox"
                  checked={data[field]}
                  onChange={onChangeFactory(field)}
                  disabled={disabled}
                />
                <i />
                {name}
              </label>
            </div>
          )}
        </div>
      )}
    </section>
  </fieldset>
